import {
  FaMapMarkerAlt,
  FaMap,
  FaCircle,
  FaListUl,
  FaTag,
  FaCreditCard,
  FaFlask,
  FaStore,
  FaCertificate,
  FaUserMd,
  FaMicroscope,
  FaUserShield,
  FaFileAlt,
  FaShareAlt,
  FaCube,
  FaTimesCircle,
  FaMoneyBillWave,
  FaStethoscope,
  FaFileSignature,
  FaBox,
  FaPercent,
  FaEye,
  FaSortAmountDown,
  FaMedkit,
  FaExternalLinkAlt,
  FaVials,
  FaDollarSign,
  FaQuestionCircle,
  FaCommentDots,
  FaCalendarDay,
  FaUser,
  FaInfoCircle,
  FaUsers,
  FaBuilding,
  FaSitemap,
  FaUserTie,
  FaUsersCog,
  FaThLarge,
  FaChartPie,
  FaCalendarTimes,
  FaFileInvoiceDollar,
  FaHospital,
  FaMoneyCheckAlt,
  FaCalendarAlt,
} from "react-icons/fa";

export const filteredNavBarLinkLists = [
  {
    category: "Doctor OPD",
    links: [
      {
        link: "/doctor-clinic-router",
        name: "Doctor Clinic Router",
        icon: <FaHospital style={{ marginRight: "15px" }} />,
      },
      {
        link: "/doctor-opd-charge-router",
        name: "Doctor OPD Charge Router",
        icon: <FaMoneyCheckAlt style={{ marginRight: "15px" }} />,
      },
      {
        link: "/doctor-schedule-router",
        name: "Doctor Schedule Router",
        icon: <FaCalendarAlt style={{ marginRight: "15px" }} />,
      },
      {
        link: "/doctor-opd-bill-item-router",
        name: "Doctor OPD Bill Item Router",
        icon: <FaFileInvoiceDollar style={{ marginRight: "15px" }} />,
      },
      {
        link: "/doctor-opd-bill-payment-router",
        name: "Doctor OPD Bill Payment Router",
        icon: <FaCreditCard style={{ marginRight: "15px" }} />,
      },
      {
        link: "/doctor-opd-appointment-router",
        name: "Doctor OPD Appointment Router",
        icon: <FaCreditCard style={{ marginRight: "15px" }} />,
      },
    ],
  },
  {
    category: "Employees",
    links: [
      {
        link: "/branch",
        name: "Branch",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/department",
        name: "Department",
        icon: (
          <FaSitemap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/designation",
        name: "Designation",
        icon: (
          <FaUserTie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/roles",
        name: "Roles",
        icon: (
          <FaUserShield
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employee",
        name: "Employee",
        icon: (
          <FaUser
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employeeType",
        name: "Employee Type",
        icon: (
          <FaUsersCog
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employeeCategory",
        name: "Employee Category",
        icon: (
          <FaUsersCog
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employeeLeave",
        name: "Employee Leave",
        icon: (
          <FaCalendarTimes
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/leaveLedgerSummary",
        name: "Ledger Summary",
        icon: (
          <FaFileInvoiceDollar
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/attendance-report",
        name: "Attendance Report",
        icon: (
          <FaThLarge
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/section",
        name: "Section",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employee-franchise-details",
        name: "Employee Franchise Details",
        icon: (
          <FaUsers
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/emp-discount-allowed",
        name: "Discount Allowed",
        icon: (
          <FaPercent
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employee-targets",
        name: "Employee Target",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Accounts & Finance",
    links: [
      {
        link: "/appointment-cancellations",
        name: "Appointment Cancellations",
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/performing-doctor-charges",
        name: "Doctor Performing Charges",
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctor-ip-calculation",
        name: "Doctor IP Calculation",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/commission-ledger",
        name: "Commission Ledger",
        icon: (
          <FaMoneyCheckAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/credit-transfer",
        name: "Credit Transfer",
        icon: (
          <FaCreditCard
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/advance-payment",
        name: "Make Advance Payment",
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/online-payment-details",
        name: "Online Payment Details",
        icon: (
          <FaUser
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/online-payments-and-receive-payment",
        name: "Online Payment Details Type",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/appointment-payment",
        name: "Patient Appointment Payment",
        icon: (
          <FaMap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-coordinator-commission",
        name: "Patient Coordinator Commission",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payment-ledger",
        name: "Payment Ledger",
        icon: (
          <FaFileInvoiceDollar
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/paymentMode",
        name: "Payment Mode",
        icon: (
          <FaCreditCard
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payment-type",
        name: "Payment Type",
        icon: (
          <FaMoneyBillWave
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payments",
        name: "Payments",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/received-payment",
        name: "Received Payment",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Agents / Coordinators",
    links: [
      {
        link: "/patient-coordinator-agents",
        name: "Patient Coordinator Agents",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-coordinator-agent-onboarding-application",
        name: "Patient Coordinator Agents Onboarding Application",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/lab-department-wise-coordinator-rates",
        name: "Lab Department Wise Coordinator rates",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/lab-department-wise-ip-rates",
        name: "Lab Department Wise IP Rates",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Doctors Management",
    links: [
      {
        link: "/doctors",
        name: "Doctor Master",
        icon: (
          <FaUserMd
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctor-onboarding-application",
        name: "Doctor Onboarding Application",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctors-degree",
        name: "Doctors Degree",
        icon: (
          <FaCertificate
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctors-sepcialization",
        name: "Doctors Specialization",
        icon: (
          <FaUserMd
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Franchise/Panel Management",
    links: [
      {
        link: "/package-copy-rate",
        name: "Package Copy Rate",
        icon: (
          <FaUser
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/new-franchise",
        name: "Document & Download",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise",
        name: "Franchise",
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-advance-payment-list",
        name: "Franchise Advance Payment",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/view-franchise-rates",
        name: "View Franchise Rates",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/view-franchise-package-rates",
        name: "View Franchise Package Rates",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/panel-master",
        name: "Franchise Copy Rates",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/panel-master-approval",
        name: "Franchise Copy Rates Approval",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-investigation-details",
        name: "Franchise Investigation Details",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-onboarding-application",
        name: "Franchise Onboarding Application",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/kyc-documents",
        name: "KYC",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-copy-rates",
        name: "Medicity Franchise Copy Rates",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/test-rate",
        name: "Test Rate",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/test-rate-list-excel",
        name: "Test Rate List Excel",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Lab Master Data",
    links: [
      {
        link: "/investigation-comment",
        name: "Investigation Comment",
        icon: (
          <FaCommentDots
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-deliveryDays",
        name: "Investigation Delivery Days",
        icon: (
          <FaCalendarDay
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-details",
        name: "Investigation Details",
        icon: (
          <FaInfoCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-help",
        name: "Investigation Help",
        icon: (
          <FaQuestionCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-interpretation",
        name: "Investigation Interpretation",
        icon: (
          <FaCommentDots
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-manager",
        name: "Investigation Manager",
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-nabl",
        name: "Investigation NABL",
        icon: (
          <FaMedkit
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-observation",
        name: "Investigation Observation",
        icon: (
          <FaEye
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-sequence",
        name: "Investigation Sequence",
        icon: (
          <FaSortAmountDown
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-template",
        name: "Investigation Template",
        icon: (
          <FaFileSignature
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-test",
        name: "Investigation/Test",
        icon: (
          <FaStethoscope
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/lab-department",
        name: "Lab Department",
        icon: (
          <FaFlask
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/observation",
        name: "Observation Master",
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/package",
        name: "Package",
        icon: (
          <FaBox
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sampleType",
        name: "Sample Type",
        icon: (
          <FaCube
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Machine & Instrumentation",
    links: [
      {
        link: "/machine-data",
        name: "Machine Data",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/observation-host-code",
        name: "Observation Host Code",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/machine-master",
        name: "Machine Master",
        icon: (
          <FaMap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Patient Management",
    links: [
      {
        link: "/membership-card",
        name: "Membership Card",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/membership-orders",
        name: "Membership Orders",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/membership-rates",
        name: "Membership Rates",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient",
        name: "Patient",
        icon: (
          <FaUser
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-appointment-details",
        name: "Patient Appointment Details",
        icon: (
          <FaUser
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Sample & Accession",
    links: [
      // {
      //   link: "/sample-collection",
      //   name: "Sample Collection",
      //   icon: (
      //     <FaStore
      //       style={{
      //         marginRight: "15px",
      //       }}
      //     />
      //   ),
      // },
      {
        link: "/rejected-sample-appointments",
        name: "Sample Rejected Appointments",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sampleRejectionReason",
        name: "Sample Rejection Reason",
        icon: (
          <FaTimesCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sample-collect-by-barcode",
        name: "Sample Collect By Barcode",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Admin",
    links: [
      {
        link: "/zone",
        name: "Zone",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/area",
        name: "Area",
        icon: (
          <FaMap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/circular",
        name: "Circular",
        icon: (
          <FaCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/collection-type",
        name: "Collection Type",
        icon: (
          <FaListUl
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/department-type",
        name: "Department Type",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-type",
        name: "Franchise Type",
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/discount-reason",
        name: "Discount Reason",
        icon: (
          <FaTag
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/organism",
        name: "Organism",
        icon: (
          <FaMicroscope
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/document",
        name: "Document",
        icon: (
          <FaFileAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/shareType",
        name: "Share Type",
        icon: (
          <FaShareAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/outsource-investigation",
        name: "Outsource Investigation",
        icon: (
          <FaExternalLinkAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/outsource-lab",
        name: "Outsource Lab",
        icon: (
          <FaVials
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-onboarding-application-approval",
        name: "Franchise Onboarding Application Approval",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctor-onboarding-application-approval",
        name: "Doctor Onboarding Application Approval",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-coordinator-agent-onboarding-application-approval",
        name: "Patient Coordinator Agent Onboarding Application Approval",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      // {
      //   link: "/panel-master",
      //   name: "Franchise Copy Rates",
      //   icon: (
      //     <FaDollarSign
      //       style={{
      //         marginRight: "15px",
      //       }}
      //     />
      //   ),
      // },
      // {
      //   link: "/estimate",
      //   name: "Estimate",
      //   icon: (
      //     <FaStore
      //       style={{
      //         marginRight: "15px",
      //       }}
      //     />
      //   ),
      // },
      {
        link: "/report-role",
        name: "Report Role",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/assign-role",
        name: "Assign Report Role",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Inventory",
    links: [
      {
        link: "/product",
        name: "Product",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/product-type",
        name: "Product Type",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/vendor",
        name: "Vendor",
        icon: (
          <FaSitemap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/terms-condition",
        name: "Terms Condition",
        icon: (
          <FaSitemap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/purchase-order",
        name: "Purchase Order",
        icon: (
          <FaSitemap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/stock-in",
        name: "Manage Stocks",
        icon: (
          <FaSitemap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Report",
    links: [
      {
        link: "/marketing-person-business-report",
        name: "Marketing Person Business Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/panne-wise-bus-report",
        name: "Pannel Wise Business Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/invoice-report",
        name: "Invoice Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-invoice-report",
        name: "Franchise Invoice Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/medicity-panel-wise-bus-report",
        name: "Medicity Pannel Wise Business Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-panel-wise-bus-report",
        name: "Franchise Pannel Wise Business Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-wise-search-report",
        name: "Result Entry",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-report",
        name: "Patient Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/commission-report-ledger",
        name: "Commission Report Ledger",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payment-type-search-report",
        name: "Payment Type Search Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/commission-report",
        name: "Commission Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-top-performer",
        name: "Franchise Top Performer",
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/tat-report",
        name: "TAT Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/tat-graphical-report",
        name: "TAT Graphical Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "MIS Report",
    links: [
      {
        link: "/booking-collection-report",
        name: "Booking Collection Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-wise-report",
        name: "Investigation Wise Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/card-collection-report",
        name: "Card Collection Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/collection-report",
        name: "Collection Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/all-payment-report",
        name: "All Payment Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/discount-report",
        name: "Discount Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/outstanding-report",
        name: "Outstanding Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
];
